<template>
    <modal-dialog
        id="lost-password-dialog"
        :show.sync="show"
        :closable="false"
        :panel_ids="['reset-password']"
        :current_panel_id.sync="current_panel_id"
        :class="{'nibnut-logo-header': !!setting('application_logo')}"
    >
        <div slot="panel-header" class="text-center">
            <div v-if="setting('application_logo')" class="px-2 py-4 mb-4">
                <img :src="setting('application_logo')" :alt="setting('application_name')" class="brand-logo">
            </div>
            <span>{{ $root.translate("Reset My Password") }}</span>
        </div>
        <template slot="panel-body">
            <form role="form" @submit.prevent.stop="reset">
                <form-input
                    v-model="email"
                    name="email"
                    type="email"
                    :live="false"
                    :error="has_error('email')"
                    :placeholder="$root.translate('Email')"
                >
                    <template v-slot:label>
                        {{ $root.translate('Email') }}
                    </template>
                </form-input>

                <form-input
                    v-model="password"
                    name="password"
                    type="password"
                    :live="false"
                    :error="has_error('password')"
                    :placeholder="$root.translate('Password')"
                >
                    <template v-slot:label>
                        {{ $root.translate('Password') }}
                    </template>
                </form-input>

                <form-input
                    v-model="password_conf"
                    name="password_conf"
                    type="password"
                    :live="false"
                    :error="has_error('password_conf')"
                    :placeholder="$root.translate('Confirm Password')"
                >
                    <template v-slot:label>
                        {{ $root.translate('Confirm Password') }}
                    </template>
                </form-input>

                <loading-button type="submit" :loading="loading" class="btn-block btn-primary mt-8">{{ $root.translate("Reset My Password") }}</loading-button>
            </form>
        </template>
    </modal-dialog>
</template>

<script type="text/javascript">
import misc_utilities from "../mixins/MiscUtilities"
import { handles_errors } from "../nibnut/mixins"

import { ModalDialog, FormInput, LoadingButton } from "../library"

export default {
    mounted: function () {
        this.token = this.$route.query.token
    },
    mixins: [misc_utilities, handles_errors],
    components: {
        ModalDialog,
        FormInput,
        LoadingButton
    },
    methods: {
        reset () {
            this.loading = true
            this.$store.dispatch("RESET_PASSWORD", {
                token: this.$route.query["password-reset"],
                email: this.email,
                password: encodeURIComponent(this.password),
                password_confirmation: encodeURIComponent(this.password_conf)
            }).then(response => {
                this.$emit("password-reset")
                if(response.message) this.$success(response.message)
                this.$router.push("/")
            }).catch(error => {
                if(error && (error.message === "__invalid__")) return this.$error(this.$root.translate("Invalid password"))
                this.receive_error(error)
            }).then(() => {
                this.loading = false
            })
        }
    },
    props: [
        "show"
    ],
    data () {
        return {
            loading: false,
            current_panel_id: "reset-password",
            email: "",
            password: "",
            password_conf: ""
        }
    }
}
</script>
